import React, { useState, useEffect } from 'react';
import { TextField, InputAdornment, Autocomplete } from '@mui/material';
import { LocationCity } from '@mui/icons-material';
import cityCameroon from './cityCameroon';

const fieldSx = {
    '& .MuiOutlinedInput-root': {
        '&:hover fieldset': { borderColor: '#153247' },
        '&.Mui-focused fieldset': { borderColor: '#153247' },
    },
    '& .MuiInputLabel-root.Mui-focused': { color: '#153247' },
};

const CityInput = ({ value, onChange, onValidation, disabled, required }) => {
    const [inputValue, setInputValue] = useState(value || '');
    const [error, setError] = useState(null);

    useEffect(() => {
        setInputValue(value || '');
    }, [value]);

    const validate = (val) => {
        if (!val || val.trim() === '') {
            const msg = required ? 'La ville est requise' : null;
            setError(msg);
            onValidation?.(msg);
            return;
        }

        setError(null);
        onValidation?.(null);
    };

    return (
        <Autocomplete
            freeSolo
            disabled={disabled}
            options={cityCameroon}
            inputValue={inputValue}
            onInputChange={(e, newInputValue) => {
                setInputValue(newInputValue);
                onChange?.(newInputValue);
                validate(newInputValue);
            }}
            onChange={(e, newValue) => {
                const val = newValue || '';
                setInputValue(val);
                onChange?.(val);
                validate(val);
            }}
            onBlur={() => validate(inputValue)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={<>Ville {required && <span style={{ color: 'red' }}>*</span>}</>}
                    error={!!error}
                    helperText={error}
                    disabled={disabled}
                    autoComplete="off"
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                            <>
                                <InputAdornment position="start">
                                    <LocationCity sx={{ color: '#153247' }} />
                                </InputAdornment>
                                {params.InputProps.startAdornment}
                            </>
                        ),
                    }}
                    sx={fieldSx}
                />
            )}
        />
    );
};

export default CityInput;